import { wrapClientApiCall } from '@kelbongoo/shared-client-react-v2/dist/components/SharedBase/wrapClientApiCall';

export const toggleCancel = ({
  taskinstances,
  setTaskInstances,
  createAlert
}) => (taskinstance_id) => () => {

  const caller = wrapClientApiCall({
    url: 'taskinstances/toggle-cancel',
  });

  return caller({
    params: { taskinstance_id }
  })
    .then(({ updatedDoc }) => {

      const index = taskinstances.findIndex(
        t => t._id === taskinstance_id
      )
      taskinstances[index].cancelledAt = updatedDoc.cancelledAt;
      taskinstances[index].cancelledBy = updatedDoc.cancelledBy;
      
      setTaskInstances(taskinstances);
    })
    .catch(err => createAlert({ message: err.message }));
};